const tabs = (tabsSelector, contentSelector, tabsParentSelector, activeClass) => {
    const tabs = document.querySelectorAll(tabsSelector),
          tabsContent = document.querySelectorAll(contentSelector),
          tabsParent = document.querySelector(tabsParentSelector);

    function hideTabContent() {
        tabsContent.forEach(item => {
            item.style.display = 'none';
        });
    
        tabs.forEach(item => {
            item.classList.remove(activeClass);
        });
    }
    
    function showTabContent(i = 0) {
        tabsContent[i].style.display = 'flex';
        tabs[i].classList.add(activeClass);
    }

    hideTabContent();
    showTabContent();

    tabsParent.addEventListener('click', function(e) {
		const target = e.target;
		if(target && target.classList.contains('tabs__item')) {
            tabs.forEach((item, i) => {
                if (target == item) {
                    hideTabContent();
                    showTabContent(i);
                }
            });
		}
	});
};

export default tabs;